module.exports = __webpack_public_path__ + "7e9bc7c78ad349a119d3c300a494dc71.png";